import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { resolveLocale } from '@/i18n';

export function LocaleSync() {
  const { i18n } = useTranslation();
  const queryClient = useQueryClient();
  const locale = resolveLocale(i18n.language);
  const previousLocale = useRef(locale);

  useEffect(() => {
    document.documentElement.lang = locale;
    // Backend payloads are localized per the X-Locale header (e.g. delivery method
    // names), so a language switch must refetch cached server state too.
    if (previousLocale.current !== locale) {
      previousLocale.current = locale;
      void queryClient.invalidateQueries();
    }
  }, [locale, queryClient]);
  return null;
}
